import { RootState } from '../store';
import { entryKey, drillEntryKey } from './reconciliationsSlice';
import { availabilityKey } from './constants';
import type { AvailabilityEntry, ReconciliationsEntry, DrillDownEntry } from './types';

export const selectReconciliationsEntry = (state: RootState, orgId: string, fys: number[] | null): ReconciliationsEntry | undefined =>
    state.reconciliations.entries[entryKey(orgId, fys)];

export const selectDrillDownEntry = (
    state: RootState,
    orgId: string,
    fys: number[] | null,
    reconId: string,
    fy: number,
): DrillDownEntry | undefined => state.reconciliations.drillDowns[drillEntryKey(orgId, fys, reconId, fy)];

export const selectAvailability = (
    state: RootState,
    orgId: string,
    fy: number | null,
    window: string | null,
): AvailabilityEntry | undefined => state.reconciliations.availability[availabilityKey(orgId, fy, window)];

export const selectOverallScore = (entry: ReconciliationsEntry | undefined) => entry?.payload?.overall ?? null;

/** recon id -> label — the `degraded.excludedReconIds` ids name recons from anywhere in the response. */
export const selectReconLabelsById = (entry: ReconciliationsEntry | undefined): Record<string, string> => {
    const sections = entry?.payload?.sections ?? [];
    return Object.fromEntries(sections.flatMap((section) => section.recons.map((recon) => [recon.id, recon.label])));
};
